// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"bb62a7b6","766":"bc835607","795":"8aebecf2"}[chunkId] + ".chunk.js";
};